import { render, staticRenderFns } from "./DeleteLiaisonDialog.vue?vue&type=template&id=8ab17b52&scoped=true&"
import script from "./DeleteLiaisonDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteLiaisonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab17b52",
  null
  
)

export default component.exports